<template>
    <FullFillBox
        :pageID="1026"
        :otherPer="[1027]"
        @permissionData="(data) => {
            this.permissionDetails = data
            if(data.add === 1){
                this.showAddButton = true
            }
            if(data.edit === 1){
                this.showEditButton = true
            }
        }"
        @otherPermission="(data) => {
            if(data[0].status === 80){
                this.showRoleManageButton = true
            }
        }"
    >
        <h3>{{ $t('sys_user_manage') }}</h3>

        <button class="btn btn-primary"
                v-if="showRoleManageButton"
                @click="toRoleMange">{{ $t('sys_role_manage') }}</button>

        <div ref="tabulatorTableUse" style="overflow: hidden;margin-top: 10px;"></div>

        <div class="btn btn-primary"
             v-if="showAddButton"
             @click="showUserDetail('add')" style="width: 200px">
            {{ $t('common_add') }}
        </div>
    </FullFillBox>

    <!--   PopupMenu Open Printer Setting List  -->
    <vue-final-modal v-model="showUserPopUp" classes="modal-container" content-class="modal-content"
                     style="margin-top: 80px;margin-right: 5%;margin-left: 5%;height: 10px">
        <button class="modal__close" @click="() => {
            showUserPopUp = false
            this.$store.commit('setIsBlackLayout', false)
        }">
            <i class="bi bi-x-lg"></i>
        </button>
        <span class="modal__title"></span>
        <div class="modal__content" style="background-color: white;border: black solid 3px;overflow: auto;height: auto">
            <div style="width: 95%;margin: auto;">
                <h3><strong>{{ $t('sys_user_manage') }}</strong></h3>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <table>
                            <tr>
                                <td style="white-space: nowrap">ID</td>
                                <td style="width: 100%;">
                                    <input style="width: 90%;margin: auto" type="number" class="form-control"
                                           :value="inputId" disabled
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td style="white-space: nowrap">{{ $t('user_show_name') }}</td>
                                <td style="width: 100%;">
                                    <input style="width: 90%;margin: auto" type="text" class="form-control"
                                           v-model="inputShowName"
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td style="white-space: nowrap">{{ $t('common_flag') }}</td>
                                <td style="width: 100%;">
                                    <select v-model="inputFlag" style="width: 90%;margin: auto" class="form-control">
                                        <option :value="true">{{ $t('sys_user_active') }}</option>
                                        <option :value="false">{{ $t('sys_user_block') }}</option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div class="col-12 col-md-6">
                        <table>
                            <tr>
                                <td style="white-space: nowrap">{{ $t('login_username') }}</td>
                                <td style="width: 100%;">
                                    <input style="width: 90%;margin: auto" type="text" class="form-control"
                                           v-model="inputUsername" :disabled="isDisabled"
                                    >
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('sys_role') }}</td>
                                <td style="width: 100%">
                                    <Multiselect
                                        v-model="inputRoleID"
                                        :options="roleList"
                                        mode="single"
                                        :can-clear=false
                                        :create-option="false"
                                        :searchable="true"
                                        :placeholder="this.$t('common_select')"
                                        style="width: 90%"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('login_password') }}</td>
                                <td style="width: 100%">
                                    <input style="width: 90%;margin: auto" type="password" class="form-control"
                                           v-model="inputPassword"
                                    >
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>

                <p class="error-text" v-if="showErrorDetail">{{ showErrorDetail }}</p>
                <p class="error-text" v-if="showError" v-for="(value, key) in showError">{{ key }} : <span>{{ value[0] }}</span></p>

                <div style="margin: auto;">
                    <button class="btn btn-primary" v-if="getFlag === 'add'" @click="confirmUpload('add')">{{ $t('sys_add') }}</button>
                    <button class="btn btn-primary" v-if="getFlag === 'update'" @click="confirmUpload('update')">{{ $t('common_update') }}</button>
                </div>

            </div>
            <br>
        </div>
    </vue-final-modal>

</template>

<script>
import FullFillBox from "@/components/routerViewLocation/FullFillBox";
import Multiselect from "@vueform/multiselect";
import {TabulatorFull as Tabulator} from "tabulator-tables";
export default {
    name: "SystemUserManageListView",
    components: {
        FullFillBox,
        Multiselect,
    },
    data(){
        return {
            permissionDetails: {},
            showAddButton: false,
            showEditButton: false,
            showRoleManageButton: false,
            perResult: '',
            inputId: '',
            inputUsername: '',
            inputShowName: '',
            inputPassword: '',
            inputFlag: '',
            inputRole: '',
            inputRoleID: '',

            showUserPopUp: false,
            roleList: [],
            getFlag: '',
            showError: '',
            showErrorDetail: '',

            showRolePopUp: false,
        }
    },
    computed: {
        isDisabled() {
            return this.getFlag !== 'add';
        },
    },
    methods: {
        toRoleMange(){
            this.$router.push('/system/role')
        },
        async confirmUpload(this_flag){
            let postData = {
                "actionUserID": this.$store.state.userServerID,
                "getFlag": this_flag,
                "beingModifyUser_UserID": this.inputId,
                "beingModifyUser_Username": this.inputUsername,
                "beingModifyUser_Show_name": this.inputShowName,
                "beingModifyUser_Password": this.inputPassword,
                "beingModifyUser_flag": this.inputFlag,
                "beingModifyUser_role": this.inputRoleID,
            }
            await this.$mainApi.post('api/client/user-manage/', postData)
                .then(response => {
                    if(response.data.status === 80){
                        this.$toast.success(this.$t('common_success'))
                        this.refreshData()
                        this.showUserPopUp = false
                        this.$store.commit('setIsBlackLayout', false)
                    }else{
                        this.showErrorDetail = response.data.details
                        this.showError = response.data.errors
                    }
                })
        },
        async refreshData(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/client/user-list/')
                .then(response => {
                    this.tabulator.setData(response.data.details)
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async getBackend(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.get('api/client/user-list/')
                .then(response => {
                    this.tabulator = new Tabulator(this.$refs.tabulatorTableUse, {
                        placeholder: "<h3>" + this.$t('common_no_data') + "</h3>",
                        maxHeight: '80vh',
                        responsiveLayout: 'collapse',
                        layout: "fitColumns",
                        movableColumns: true,
                        movableRows: false,
                        groupStartOpen: false,
                        data: response.data.details,
                        columns: [
                            {
                                width:100, responsive:0,
                                title: "ID",
                                field: "id",
                                sorter: "number",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('user_username'),
                                field: "username",
                                sorter: "string",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('user_show_name'),
                                field: "show_name",
                                sorter: "string",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:0, minWidth: 50,
                                title: this.$t('sys_role'),
                                field: "role",
                                sorter: "string",
                                headerFilter:"list",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {
                                widthGrow:1, responsive:5, minWidth: 100,
                                title: this.$t('common_create_date'),
                                field: "createTime",
                                sorter: "string",
                                headerFilter:"input",
                                headerFilterParams:{
                                    valuesLookup:true, sort:'asc', clearable:true, autocomplete:true, listOnEmpty: true
                                },
                            },
                            {formatter: this.subEditIcon,
                                headerHozAlign:"center", hozAlign:"center", vertAlign: "middle", resizable:false,
                                headerSort:false, width:10, responsive:0,
                                cellClick:
                                    (e, row, formatterParams) => {
                                        if(this.showEditButton){
                                            this.showUserDetail("update", row.getData().id)
                                        }else{
                                            this.$toast.error(this.$t('error_no_permission'))
                                        }
                                    }
                                ,
                            },
                            {formatter:"tickCross", headerHozAlign:"center", hozAlign:"center", vertAlign: "middle",
                                resizable:false, field: 'flag', width:10, responsive:0
                            },
                        ],
                    })
                })
            this.$store.commit('setIsTopLoading', false)
        },
        async showUserDetail(flag, userID){
            if((flag === 'update') || (flag === 'add')){
                await this.getRoleList()
                if(flag === "update"){
                    this.getFlag = 'update'
                    await this.$mainApi.get(`api/client/user-details/${userID}`)
                        .then(response => {
                            if(response.data.status === 80){
                                let res = response.data.details
                                this.inputId = res.id
                                this.inputUsername = res.username
                                this.inputShowName = res.show_name
                                this.inputFlag = res.flag
                                this.inputRole = res.role
                                this.inputRoleID = res.roleID
                                this.inputPassword = ""
                            }else{
                                this.$toast.error(this.$t('sys_user_not_exist'))
                                this.$router.go(0)
                            }
                        })
                }else{
                    this.getFlag = 'add'
                    this.inputId = ""
                    this.inputUsername = ""
                    this.inputShowName = ""
                    this.inputFlag = true
                    this.inputRole = ""
                    this.inputPassword = ""
                }

                this.showError = ""
                this.showErrorDetail = ""
                this.showUserPopUp = true
                this.$store.commit('setIsBlackLayout', true)
            }else{
                this.$toast.error(this.$t('common_error_no_per'))
            }
        },
        subEditIcon(cell, formatterParams){
            return "<i class='bi bi-pencil-fill\'></i>";
        },
        async getRoleList(){
            await this.$mainApi.get(`api/client/role/`)
                .then(response => {
                    this.roleList = []
                    for (let i=0;i<response.data.details.length;i++) {
                        this.roleList.push({
                            value: response.data.details[i]['id'],
                            label: response.data.details[i]['roleName'],
                        });
                    }
                })
        }
    },
    async mounted() {
        document.title = this.$t('title') + ' | ' + this.$t('user_manage')
        await this.getBackend()
    }
}
</script>

<style scoped>

</style>
